import React, { useEffect, useState } from 'react'
import {
    Text, View, Image, StyleSheet, ScrollView, ImageBackground
} from 'react-native';
import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import { getAayuCardActivityDatetime } from '../../utils/services/DateTimeUtils';
import { doPost } from '../../utils/services/api/API';
import * as CommonUtils from "../../utils/services/CommonUtils";
import * as ScreenShimmer from "../shimmer-component/ScreenShimmer";
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { store } from '../../store/store';
import { SubscriptionAayuCardDesign } from '../../utils/widgets/AayuCard/AayuCardDesign';
import { resetRedux } from '../../utils/services/redux/commonRedux';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { PrimaryCTA } from '../../utils/widgets/CommonCTA';


const PostPurchaseAayu = (props) => {

    const reduxState = store.getState()

    const [subscriptionData, updateSubsData] = useState(reduxState.subscriptionData)

    const getUserName = (userData: any) => {
        var uName = '';
        userData['familyMembers'].forEach(member => {
            if (member.id == userData['userId'])
                uName = member.name;
        });
        return uName;
    }

    const checkConsultLeftString = () => {
        if (subscriptionData['consultLeft'] > 1)
            return 'Consultations';
        else return 'Consultation';
    }

    const checkConsultLeftImage = () => {
        if (subscriptionData['consultLeft'] > 2)
            return '/images/aayuCard/aayu_subs_remaining_green.svg'
        else return '/images/aayuCard/aayu_subs_remaining_yellow.svg'
    }

    const checkFirstConsultation = () => {
        if (subscriptionData['maxConsultations'] == subscriptionData['consultedCount'])
            return 'TAKE FIRST CONSULTATION';
        else return 'TAKE CONSULTATION';
    }

    const getAayuCardData = () => {
        doPost('accounts/get_app_basic_data', { getExtendedData: false }).then(
            (response: any) => {
                if (response.status == 401) {
                    resetRedux();
                    setTimeout(() => {
                        props.navigation.popToTop();
                        props.navigation.replace('splash')
                    }, (500));
                } else {
                    const userData = response?.familyData;
                    const subsData = response?.subscriptions?.aayuCardSubscription ?? {};
                    var subscriptionData = subsData
                    subscriptionData['userName'] = getUserName(userData)
                    subscriptionData['consultLeft'] = subsData['maxConsultations'] - subsData['consultedCount']
                    subscriptionData['validFromDate'] = getAayuCardActivityDatetime(subsData['addedOn'])
                    subscriptionData['validTillDate'] = getAayuCardActivityDatetime(subsData['validTill'])
                    updateSubsData(subscriptionData)
                }
            }, err => console.log(err)
        )
    }



    useEffect(() => {
        getAayuCardData();
    }, [])

    return (
        <View style={{ backgroundColor: AppTheme.color.background, minHeight: AppTheme.appHeight }}>
            <CommonHeader onBackPressRoute={ScreenRoute.tab_controller_screen} navigation={props.navigation} title='Aayu Card' />

            {subscriptionData && Object.keys(subscriptionData).length > 0 ?
                <View style={{ marginTop: AppTheme.headerHeight }}>

                    <ScrollView style={{ backgroundColor: AppTheme.color.background }}>

                        <View style={[AppStyles.flexRow, {
                            backgroundColor: 'white', alignContent: "center",
                            paddingTop: 20, paddingBottom: 70, paddingHorizontal: 16
                        }]}>
                            <ImageBackground source={{ uri: CommonUtils.getImagePath(checkConsultLeftImage()), width: 60, height: 60 }}
                                style={{ paddingHorizontal: 15, paddingVertical: 15 }}>
                                <View style={{ alignItems: "center", justifyContent: "center", width: 30, height: 30 }}>
                                    <Text style={styles.consultCount}><b>{subscriptionData['consultLeft']}</b></Text></View>
                            </ImageBackground>
                            <View style={{ width: 8 }} />
                            <Text style={{ fontSize: 20 }}><b>Remaining {checkConsultLeftString()}</b></Text>
                        </View>

                        <View style={{
                            position: 'absolute', top: 94, marginHorizontal: 16,
                            width: AppTheme.appWidth - 32, height: (AppTheme.appWidth - 32) * 0.45
                        }}>
                            <SubscriptionAayuCardDesign subscriptionData={subscriptionData} />
                        </View>

                        <View style={[AppStyles.flexRowCenter, { marginHorizontal: 16, marginTop: (AppTheme.appWidth - 32) * 0.45 - 18 }]}>
                            <Image source={{ uri: CommonUtils.getImagePath('/images/aayuCard/aayu_subs_sheild.svg'), width: 30, height: 30 }}
                                style={{ shadowRadius: 6, shadowOpacity: 0.6, marginRight: 8 }} />
                            <Text style={{ fontSize: 16, color: AppTheme.color.black }}>
                                Your Aayu card subscription is <Text style={{ fontWeight: "600" }}>ACTIVE</Text></Text>
                        </View>

                        <View style={{ marginTop: 48, marginBottom: 70, }}>
                            <Image source={{
                                uri: CommonUtils.getImagePath('/images/aayuCard/aayu_subs_secure_banner.png'),
                                width: AppTheme.appWidth, height: AppTheme.appWidth * 0.6
                            }} style={{ resizeMode: 'contain' }} />

                        </View>

                    </ScrollView>

                    <View style={[AppStyles.mediumShadow, {
                        bottom: 0, width: AppTheme.appWidth, position: 'fixed',
                        backgroundColor: 'white', paddingVertical: 16
                    }]}>
                        <PrimaryCTA text={checkFirstConsultation()}
                            onPress={() => {
                                props.navigation.pop();
                                props.navigation.navigate(ScreenRoute.member_selection);
                            }} />
                    </View>
                </View> : <ScreenShimmer.PostPurchaseShimmer />
            }
        </View>
    )
}

export default PostPurchaseAayu;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    consultCount: {
        fontSize: 20, textAlign: 'center',
        color: AppTheme.color.black
    },
    text: {
        textAlign: 'center',
        marginTop: 20,
        fontSize: 20,
    },


}))